import { z } from 'zod';

const PASSWORD_RULES = [
  {
    test: (val: string) => val.length >= 8,
    message: 'Password must be at least 8 characters',
  },
  {
    test: (val: string) => /[A-Z]/.test(val),
    message: 'Password must contain at least one uppercase letter',
  },
  {
    test: (val: string) => /[a-z]/.test(val),
    message: 'Password must contain at least one lowercase letter',
  },
  {
    test: (val: string) => /[0-9]/.test(val),
    message: 'Password must contain at least one number',
  },
];

export const passwordSchema = z
  .string()
  .trim()
  .min(1, 'Password is required')
  .superRefine((val, ctx) => {
    for (const rule of PASSWORD_RULES) {
      if (!rule.test(val)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: rule.message,
        });
      }
    }
  });

export const parentLoginSchema = z.object({
  email: z.preprocess(
    (val) => (typeof val === 'string' ? val.trim().toLowerCase() : val),
    z.string().email('Please enter a valid email'),
  ),
  password: passwordSchema,
});

export type ParentLoginInput = z.infer<typeof parentLoginSchema>;
